import Logo from "../assets/Logo.png";
import Slide1 from "../assets/slide1.png";

type Props = {
  src: any;
};

const Page2 = (props: Props) => {
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div className="w-[384px] h-[256px] -mt-2 bg-[#181818] flex scale-y-125 scale-x-[1.14] flex-col items-center overflow-hidden">
        <img src={props.src} className="w-full h-full" />
      </div>
    </div>
  );
};

export default Page2;
